export const useShippingStore = defineStore('shipping', () => {
  const title = ref(null)
  const subtitle = ref(null)
  const type = ref(null)
  const options = ref<any | null>(null)
  const method = ref<string | null>(null)
  const timeframe = ref(null)
  const expectedDelivery = ref(null)
  const message = ref(null)
  const pickupAddress = ref(null)
  const shopAddress = ref(null)
  const address = ref<Partial<AddressItem>>({})

  const reset = () => {
    title.value = null
    subtitle.value = null
    type.value = null
    options.value = null
    method.value = null
    timeframe.value = null
    expectedDelivery.value = null
    message.value = null
    pickupAddress.value = null
    shopAddress.value = null
    address.value = {}
  }

  return {
    title,
    subtitle,
    type,
    options,
    method,
    timeframe,
    expectedDelivery,
    message,
    pickupAddress,
    shopAddress,
    address,
    reset
  }
}, {
  persistedState: {
    persist: true,
    includePaths: ['address']
  }
})
